<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          TAXONOMY
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Taxonomy List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              placeholder="Search"
              single-line
              hide-details
              @keyup="searchTaxonomy()"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <v-btn
              id="add-taxonomy"
              :to="{ name: 'taxonomyCreate' }"
              color="secondblue"
              class="white--text"
            >
              <v-icon left dark>add</v-icon>
              Add new Taxonomy
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="taxonomies"
          :search="search"
          :loading="loading"
          :must-sort="true"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item.costElement="{ item }">
            {{ item.costElement ? item.costElement.desc : '-' }}
          </template>
          <template v-slot:item.costCenter="{ item }">
            {{ item.costCenter ? item.costCenter.desc : '-' }}
          </template>
          <template v-slot:item.category="{ item }">
            {{ item.category || '-' }}
          </template>
          <template v-slot:item.created_by="{ item }">
            {{
              item.logCreate
                ? item.logCreate.length > 0
                  ? item.logCreate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.updated_by="{ item }">
            {{
              item.logUpdate
                ? item.logUpdate.length > 0
                  ? item.logUpdate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              :id="'btn-detail' + item.id"
              icon
              @click="toDetail(item.id)"
              v-if="hasPermission('view_master_data', 'view')"
            >
              <v-icon medium color="green">remove_red_eye</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-edit' + item.id"
              @click="toEdit(item.id)"
              icon
              v-if="hasPermission('update_master_data', 'update')"
            >
              <v-icon medium color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-delete' + item.id"
              @click="deleteItem(item.id)"
              icon
              v-if="hasPermission('delete_master_data', 'delete')"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: false,
      loading: false,
      search: '',
      isSearch: false,
      totalItems: 0,
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      descending: true,
      sort: '',
      options: {
        itemsPerPage: 5
      },
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Taxonomy List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      headers: [
        {
          text: 'Code',
          value: 'code'
        },
        {
          text: 'PCTR',
          value: 'pctr'
        },
        {
          text: 'MAT Group',
          value: 'mat_group'
        },
        {
          text: 'AR1',
          value: 'ar1'
        },
        {
          text: 'BPC',
          value: 'bpc'
        },
        {
          text: 'Code Cost Element',
          value: 'code_cost_element'
        },
        {
          text: 'Cost Element Desc',
          value: 'costElement'
        },
        {
          text: 'Code Cost Center',
          value: 'code_cost_center'
        },
        {
          text: 'Cost Center Desc',
          value: 'costCenter'
        },
        {
          text: 'Category',
          value: 'category'
        },
        {
          text: 'Created At',
          value: 'created_at'
        },
        {
          text: 'Created By',
          value: 'created_by'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Updated By',
          value: 'updated_by'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      taxonomies: [],
      timeout: null
    };
  },
  watch: {
    descending(value) {
      console.log(value);
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchTaxonomy() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      const search = {
        code: this.search,
        code_cost_element: this.search,
        code_cost_center: this.search,
        mat_group: this.search,
        pctr: this.search,
        ar1: this.search,
        bpc: this.search
      };
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      this.$store
        .dispatch('taxonomy/getAll', {
          page,
          sort,
          limit: itemsPerPage,
          search
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.taxonomies = data.data.result;

            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this taxonomy!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          this.$store.dispatch('taxonomy/delete', id).then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Deleted!', data.message.text_en, 'success');
            this.getData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your taxonomy data has been undeleted',
            'error'
          );
        }
      });
    },
    toEdit(id) {
      this.$router.push({
        name: 'taxonomyEdit',
        params: { id: id }
      });
    },
    toDetail(id) {
      this.$router.push({
        name: 'taxonomyDetail',
        params: { id: id }
      });
    }
  }
};
</script>
